import {RestService} from "@/services/rest/RestService";
import {ContentBlockEnumEndpointsApi} from "@/api/pharma-cms-content-block";
import {CodeDescriptionRestDto} from "@/api/pharma-cms-content-block/models";

export class ContentBlockEnumRestService extends RestService {

    private apiService: ContentBlockEnumEndpointsApi;

    /**
     * The list is stable for the lifetime of the session and is asked for on every "add column"
     * click, so it is cached per filter value instead of hitting the backend every time.
     */
    private structureTypeEnums: Map<boolean, CodeDescriptionRestDto[]> = new Map<boolean, CodeDescriptionRestDto[]>();

    protected constructor() {
        super();

        this.apiService = new ContentBlockEnumEndpointsApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().cmsUrl);
    }

    public async findContentBlockStructureTypeEnums(filterIsSupportedOnPage: boolean = false): Promise<CodeDescriptionRestDto[]> {
        const cached = this.structureTypeEnums.get(filterIsSupportedOnPage);
        if (cached) {
            return cached;
        }

        const response = await this.apiService.findContentBlockStructureTypeEnums(undefined, filterIsSupportedOnPage);
        this.structureTypeEnums.set(filterIsSupportedOnPage, response.data);

        return response.data;
    }
}
